export const RIVETAI_ANALYTICS_SURFACE = {
  marketingWebsite: "marketing_website",
  productApp: "product_app",
} as const;

export type RivetaiAnalyticsSurface =
  (typeof RIVETAI_ANALYTICS_SURFACE)[keyof typeof RIVETAI_ANALYTICS_SURFACE];

import { buildAnalyticsPathTemplate } from "./analytics-path-template";

export const POSTHOG_PAGEVIEW_EVENT = "$pageview";
export const POSTHOG_PAGELEAVE_EVENT = "$pageleave";

export const buildPosthogPageViewProperties = (
  surface: RivetaiAnalyticsSurface,
  pathname: string,
  search = ""
): Record<string, string> => {
  const normalizedSearch = search.startsWith("?") ? search : search ? `?${search}` : "";
  const pathWithSearch = `${pathname}${normalizedSearch}`;
  const pathTemplate = buildAnalyticsPathTemplate(pathname);

  if (typeof window === "undefined") {
    return {
      rivetai_surface: surface,
      $pathname: pathTemplate,
    };
  }

  return {
    rivetai_surface: surface,
    $current_url: `${window.location.origin}${pathWithSearch}`,
    $pathname: pathTemplate,
    $host: window.location.host,
    ...(normalizedSearch ? { $search: normalizedSearch } : {}),
  };
};

export const buildPosthogPageLeaveProperties = (
  surface: RivetaiAnalyticsSurface,
  pathname: string
): Record<string, string> => {
  const pathTemplate = buildAnalyticsPathTemplate(pathname);

  if (typeof window === "undefined") {
    return {
      rivetai_surface: surface,
      $pathname: pathTemplate,
    };
  }

  return {
    rivetai_surface: surface,
    $current_url: `${window.location.origin}${pathname}${window.location.search}`,
    $pathname: pathTemplate,
    $host: window.location.host,
  };
};
